/** @format */

export const FilterListReducerFieldName = {
    HEADER_FILTER_MANAGE: 'headerFilterListManage',
    HEADER_FILTER_ELEMENT_HAS_VALUE: 'headerFilterListElementHasValue',
    HEADER_FILTER_ELEMENT_NAME: 'headerFilterListElementName',
    HEADER_FILTER_MANAGE_ELEMENT: 'headerFilterListManageElement'
};

export type FilterListReducers = {
    type: string;
    columnName?: string;
    elementList?: Array<object>;
    headerFilterListElementName?: string;
    headerFilterListElementHasValue?: boolean;
    headerFilterListElementValue?: any;
    headerFilterListElementRawValue?: any;
    showRender?: boolean;
};

export function filterListReducer(state: any, action: FilterListReducers): object {
    switch (action.type) {
        case FilterListReducerFieldName.HEADER_FILTER_MANAGE:
            return action;
        case FilterListReducerFieldName.HEADER_FILTER_MANAGE_ELEMENT:
            return action;
        default:
            return {
                ...state,
            };
    }
}
